import { render, staticRenderFns } from "./modalAfiliacion.vue?vue&type=template&id=1200702a&scoped=true"
import script from "./modalAfiliacion.vue?vue&type=script&lang=js"
export * from "./modalAfiliacion.vue?vue&type=script&lang=js"
import style0 from "./modalAfiliacion.vue?vue&type=style&index=0&id=1200702a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1200702a",
  null
  
)

export default component.exports